import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchRepatriationsTransactionsEdit = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editRepatriationsTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.put(serviceUrl, {
    departureDateTime: moment(payload.params.departureDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
    description: payload.params.description,
    inboundImpc: payload.params.inboundImpc,
    inboundOperator: payload.params.inboundOperator,
    plannedArrivalDateTime: moment(payload.params.plannedArrivalDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
    quantity: payload.params.quantity,
    transactionId: payload.params.transactionId,
  });
};

export default apiFetchRepatriationsTransactionsEdit;
